module.exports = __webpack_public_path__ + "img/client_registry_mzk.257c8aad.png";